import apiClient from "./http";

export const getProperties = (page = 1, pageSize = 20) =>
  apiClient.get("/Properties", { params: { page, pageSize } });

export const createProperty = (payload) => apiClient.post("/Properties", payload);

export const updateProperty = (id, payload) =>
  apiClient.put(`/Properties/${id}`, payload);

export const deleteProperty = (id) => apiClient.delete(`/Properties/${id}`);

export const getPropertyById = () => {
  // Blocked — backend API not defined in implementation doc.
  return Promise.reject(
    new Error("Blocked — backend API not defined in implementation doc")
  );
};
